import React from 'react';
import FinanceCard from './FinanceCard';

function Dashboard({
  user,
  onLogout,
  financialData,
  loadingType,
  error,
  onFetch
}) {

  const cards = [
    { id: 1, title: 'Mutual Funds', type: 'mutual_funds', template_id: 'CTMP2512111448565027PGB9CHTZ1KZA' },
    { id: 2, title: 'Equities', type: 'equities', template_id: 'CTMP251211144856502UEYOXHSGMKUG5'},
    { id: 3, title: 'ETF', type: 'etf', template_id: 'CTMP251211144856502S4WBNBOS4Q67J'},
    { id: 4, title: 'Bank Accounts', type: 'bank_accounts', template_id: 'CTMP2512111448565033COAA9YG4QD45' },
    { id: 5, title: 'NPS', type: 'nps', template_id: 'CTMP251211144856502W3ILV7E21MNFE' }
  ];

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>Dashboard</h1>
          <p style={styles.welcome}>Welcome, {user.name}</p>
        </div>
        <button onClick={onLogout} style={styles.logoutButton}>
          Logout
        </button>
      </div>

      <div style={styles.grid}>
      {cards.map(card => (
      <FinanceCard
        key={card.id}
        title={card.title}
        type={card.type}
        templateId={card.template_id}
        data={financialData[card.type]}
        loading={loadingType === card.type}
        error={error}
        onFetch={onFetch}
      />
    ))}
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f5f5f5',
    padding: '40px 20px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '30px',
    maxWidth: '1200px',
    margin: '0 auto 30px',
  },
  title: {
    margin: '0 0 5px 0',
    color: '#333',
  },
  welcome: {
    margin: 0,
    color: '#666',
  },
  logoutButton: {
    padding: '10px 20px',
    backgroundColor: 'white',
    color: '#1976d2',
    border: '1px solid #1976d2',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '20px',
    maxWidth: '1200px',
    margin: '0 auto',
  },
};

export default Dashboard;